export default {
  description: `Bir kitabım, okuyanı düşünmeye sevk etmezse, çabucak anlaşılırsa yazdıklarım kusurlu demektir. Okuyucular üslubumu basitleştirmemi isteseler de ben okuyucunun eserim üzerine kafa yormasını, gerekirse onu tekrar tekrar okumasını isterim. Eserlerimdeki yoğunluğun, anlam çeşitliliğinin nedeni budur. Bu yüzden eserlerimin çok satılmamasını hiç önemsemiyorum.`,
  title: `Düşüncelerini bu şekilde dile getiren yazarla ilgili aşağıdakilerden hangisi söylenemez?`,
  options: [
    {
      title: `Okurların ilgisini çekmeyen konulara değinir.`,
      isTrue: true
    },
    {
      title: `Anlaşılması için üzerinde çok düşünülmesi gereken eserler kaleme alır.`,
      isTrue: false
    },
    {
      title: `Maddi kaygı gözetmeden kitap yazar.`,
      isTrue: false
    },
    {
      title: `Okuyucunun beklentilerini önemsemez.`,
      isTrue: false
    }
  ],
  id: 1
};



// WEBPACK FOOTER //
// ./src/assets/sorular/lgs/1.js